module.exports = "<div class=\"fa fa-spinner fa-spin loader\" *ngIf=\"loading\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loader/loader.component.html
// module id = ./src/app/shared/loader/loader.component.html
// module chunks = main